module.exports = __webpack_public_path__ + "img/feedback1-3.ba2aa641.jpg";